import React, { Component } from "react";

import "./styles.css";

class CopyDeleteMenu extends Component {
  componentDidUpdate(prevProps) {
    if (
      !prevProps.valueShare?.shareValue &&
      this.props.valueShare?.shareValue
    ) {
      const newValue =
        this.props.valueShare.totalValue /
        this.props.valueShare.questionsAmount;
      this.props.questionValueChanger(this.props.questionId, newValue);
    }
  }

  render() {
    return (
      <div className="copy-delete-value-section">
        <p>Valor da questão:</p>
        <input
          type="number"
          value={
            this.props.valueShare.shareValue
              ? Math.round(
                  (this.props.valueShare.totalValue /
                    this.props.valueShare.questionsAmount) *
                    100
                ) / 100
              : this.props.questionValue !== null
              ? Math.round(this.props.questionValue * 100) / 100
              : null
          }
          readOnly={this.props.valueShare.shareValue}
          min="0"
          max="99"
          disabled={this.props.disabled}
          onChange={e =>
            this.props.questionValueChanger(
              this.props.questionId,
              e.target.value.replace(",", ".")
            )
          }
        />
        <div className="question-list-section-divisor" />
        <button
          onClick={() => this.props.questionDuplicator()}
          disabled={this.props.disabled}
        >
          <i className="fa fa-copy fa-lg"></i>
        </button>
        {!this.props.released && (
          <button
            onClick={() => this.props.questionEditor()}
            disabled={this.props.disabled}
          >
            <i className="fa fa-edit fa-lg"></i>
          </button>
        )}
        <button
          onClick={() => this.props.questionDeleter()}
          className="delete-question-button"
          disabled={this.props.disabled}
        >
          <i className="fa fa-trash fa-lg"></i>
        </button>
      </div>
    );
  }
}

export default CopyDeleteMenu;
